import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  failureAction,
  requestAction,
  successAction,
  successItemAction
} from '~/utils/reducerFunctions'

export interface ClinicState {
  data: Clinic[]
  item: Partial<Clinic>
  loading: boolean
  loaded: boolean
  error: any
  meta: Meta
}

export const initialState: ClinicState = {
  data: [],
  item: {},
  loading: false,
  loaded: false,
  error: null,
  meta: {
    count: 0,
    pages: 1,
    page: 1
  }
}

const clinicsSlice = createSlice({
  name: 'clinics',
  initialState,
  reducers: {
    request: requestAction,

    success: (
      state,
      action: PayloadAction<{ data: Clinic[]; meta: Meta }>
    ): void => {
      successAction(state, action, 'data', (state) => {
        const {
          payload: { data, meta }
        } = action

        state.data = data
        state.meta = meta
      })
    },

    successItem: successItemAction,

    failure: failureAction
  }
})

export const { request, success, successItem, failure } = clinicsSlice.actions

export default clinicsSlice.reducer
